import React from 'react'
import { Status } from '@ztechapps/webui.util'
import { ProductStatusEnum } from '@ztechapps/common.contract'

export const ProductStatus = ({ value }) => {
  let type
  if (value?.toLowerCase() === ProductStatusEnum.InActive.toLowerCase()) {
    type = 'muted'
  } else if (value?.toLowerCase() === ProductStatusEnum.Draft.toLowerCase()) {
    type = 'warning'
  } else {
    type = 'info'
  }

  return <Status value={value} type={type} />
}
